import React from "react";
import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import ActiveFilterItem from "./ActiveFilterItem";

export const GET_COUNTRY = gql`
  query Countries($id_list: [Int]) {
    countries(id_list: $id_list) {
      _id
      name
    }
  }
`;

const ActiveFilterCountry = ({ IdList, removeAction, change }) => {
  const { data, loading, error } = useQuery(GET_COUNTRY, {
    variables: {
      id_list: IdList
    }
  });

  if (error) return "error";
  if (loading) return "";

  return (
    <>
      {data.countries.map(it => (
        <ActiveFilterItem
          label={it.name}
          key={it._id}
          type={"REMOVE_COUNTRY"}
          payload={it._id}
          remove={removeAction}
          change={change}
        ></ActiveFilterItem>
      ))}
    </>
  );
};

export default ActiveFilterCountry;
